var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sd-sec",attrs:{"id":_vm.id}},[_c('span',{staticClass:"bar"}),_c('h2',[_vm._v(_vm._s(_vm.title))]),(_vm.note)?_c('span',{staticClass:"note"},[_vm._v(_vm._s(_vm.note))]):_vm._e(),_c('span',{staticClass:"grow"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }